import { Vector2, Container } from '@cgs/wge';
import { AbstractSpinConfig } from './abstract_spin_config';
import { SpinConfig, AnticipationConfig, IconWithValuesConfig, StaticConfig } from './game_config';
import { AbstractGameConfig } from './abstract_game_config';

export class GameModuleConfig implements AbstractGameConfig {
  public regularSpinConfig: SpinConfig;
  public freeSpinConfig: SpinConfig;
  public buyFeatureConfig: SpinConfig | null = null;
  public anticipationConfig: AnticipationConfig;
  public iconWithValuesConfig: IconWithValuesConfig;
  public staticConfig: StaticConfig;

  private readonly _displayResolution: Vector2;
  private readonly _configDto: Map<any, any>;
  private readonly _fps: number;

  constructor(container: Container, configDto: Map<any, any>, displayResolution: Vector2) {
    this._configDto = configDto;
    this._displayResolution = displayResolution;
    this._fps = 50;

    if (this._configDto) {
      if (this._configDto.has('regularSpin')) {
        this.regularSpinConfig = new SpinConfig(
          container,
          this._configDto.get('regularSpin'),
          Math.round(this._displayResolution.y)
        );
      }

      if (this._configDto.has('freeSpin')) {
        this.freeSpinConfig = new SpinConfig(
          container,
          this._configDto.get('freeSpin'),
          Math.round(this._displayResolution.y)
        );
      }

      if (this._configDto.has('buyFeature')) {
        this.buyFeatureConfig = new SpinConfig(
          container,
          this._configDto.get('buyFeature'),
          Math.round(this._displayResolution.y)
        );
      }

      if (this._configDto.has('anticipationParameters')) {
        this.anticipationConfig = new AnticipationConfig(
          this._configDto.get('anticipationParameters'),
          this._fps,
          Math.round(this._displayResolution.y)
        );
      }

      if (this._configDto.has('iconWithValuesParameters')) {
        this.iconWithValuesConfig = new IconWithValuesConfig(
          this._configDto.get('iconWithValuesParameters')
        );
      }

      if (this._configDto.has('staticConfig')) {
        this.staticConfig = new StaticConfig(this._configDto.get('staticConfig'));
      }
    }
  }

  getNamedConfig(_name: string): AbstractSpinConfig | null {
    return null;
  }

  getFakeConfig(name: string): any {
    return this._configDto.has(name)
      ? new StaticConfig(this._configDto.get(name))
      : new StaticConfig(this._configDto.get('staticConfig'));
  }

  getSlotFeatureConfig(_type: any): any {
    return null;
  }
}
